import { Component, OnInit, OnChanges } from '@angular/core';
import { ActivatedRoute, Routes } from '@angular/router';
import { SmallshiService } from '../../services/smallshi.service';
import { LocationService } from '../../services/location.service';
import { DataDeliveryService } from '../../services/data-delivery.service';
import Swal from 'sweetalert2';
import { CarritoControlerService } from 'src/app/services/carrito-controler.service';


@Component({
  selector: 'app-comercio',
  templateUrl: './comercio.component.html'
})
export class ComercioComponent {
  public idComercio = '';
  public ecomerce = '';
  public cateSelected: string = '';
  public etiquetasCom: string = 'todos';
  public flagTx = true;
  public flujo = '2';
  public validaMesa: boolean = false;
  public loading = true;
  public location = {};
  // public etiquetas = '';
  // public controlDelivery = 0;
  public totalTime = 3;
  public finalizar: boolean = false;
  public nuevasTiendas: any = {};
  public nuevasCategorias: any[] = [];
  public horarios: any[];
  public flagHorarios: boolean;
  public now: Date;
  constructor(private activateRoute: ActivatedRoute,
    private small: SmallshiService,
    private lct: LocationService,
    private delivery: DataDeliveryService) {
    this.activateRoute.params.subscribe(params => {
      this.idComercio = params['id'];
      if (!params['etiqueta']) {
        small.etiquetaComercio = '';

      } else {
        if (params['etiqueta'] == 0 && params['mesa']) {
          small.mesaComercio = params['mesa'];
          small.validaMesa = true;
        } else {
          small.etiquetaComercio = params['etiqueta'];
        }
      }
      this.getCategories(params['id']);
      small.datosApi('anonimo', ' ', 'anonimo', 'anonimo', '', '', '', this.flujo);
    });
    navigator.geolocation.getCurrentPosition(function (position) {
      delivery.latitud = position.coords.latitude;
      delivery.longitud = position.coords.longitude;
    });
    this.now = new Date();
    // toca hacerlo, pero no aca, la logica esta mal de validar mesa, revisar con rafa, el la tiene mas clara
    // if (!small.validaMesa) {
    //   this.small.getHorarios(this.idComercio).subscribe((horarios: any) => {
    //     this.horarios = horarios.data;
    //     const index_horario = (element) => this.now <= new Date(this.now.getUTCFullYear(), this.now.getMonth(), this.now.getDate(), element.hora.substr(0, 2), element.hora.substr(3, 2), element.hora.substr(6, 2));
    //     // console.log(this.horarios.findIndex(index_horario));
    //     if (this.horarios.findIndex(index_horario) !== -1) {
    //       this.small.idhentrega = this.horarios[this.horarios.findIndex(index_horario)].id;
    //       this.flagHorarios = true;
    //     } else {
    //       this.flagHorarios = false;
    //       Swal.fire({
    //         icon: 'info',
    //         text: `No hay horario de reparto para hoy.`
    //       });
    //     }
    //   });
    // } // if valida mesa
  }




  validarecomerce(tienda: any[]) {

    setTimeout(() => {
      this.nuevasTiendas = tienda;
      // if (this.nuevasTiendas.servicios === 1) this.flagTx = true;
      // else this.flagTx = false;
      this.flagTx = false;
      this.loading = false;

      if (this.small.validaMesa) this.ecomerce = '1';
      else this.ecomerce = (this.flagHorarios ? this.nuevasTiendas.ecommerce : '0');

      this.small.controlDelivery = Number(this.nuevasTiendas.controlDelivery);
    }, 1000);


  }


  getCategories(comercio: string) {
    this.cateSelected = '';
    this.small.getCategories(comercio, '', 'todos').subscribe((data: any) => {
      if (data.status) {
        this.nuevasCategorias = data.data;
        this.cateSelected = this.nuevasCategorias[0].category_id;
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops algo ocurrió...',
          text: data.message
        });
      }
    });
  }

  iraComercio(tp) {
    if (tp === 0) {
      //let urlComercio ="https://crm-test.smallshi.com/reservas/index2.html?id="+this.nuevasTiendas.id;
      const urlComercio = this.small.urlReservas + 'reservas/index2.html?id=' + this.nuevasTiendas.id;
      window.location.href = urlComercio;
    } else {
      this.flagTx = false;
    }
  }
  cargaProductos(idCategoria: string) {
    this.cateSelected = idCategoria;
  }
  cerrarCatalogo(flagFinalizacion: boolean) {
    if (flagFinalizacion) {
      this.finalizar = flagFinalizacion;
      this.updateClock();
    } else {
      this.finalizar = false;
      //this.oops = true;
    }

  }

  updateClock() {
    this.validaMesa = this.small.validaMesa;
    if (this.totalTime == 0) {
      if (!this.validaMesa) {
        this.cerrar();
      }
    } else {
      this.totalTime -= 1;

      setTimeout(() => {
        this.updateClock();
      },
        1000);

    }
  }
  cerrar() {
    if (this.validaMesa) {
      window.location.reload();
    } else {
      window.location.href = this.small.urlRetorno;
    }
  }
  cortar(cadena: string, cantidad: number) {
    return (cadena.length > cantidad ? cadena.substring(0, cantidad) + "..." : cadena);
  }

  buscarProductos() {
    this.small.filtroHtml = ((document.getElementById("buscadorHtml") as HTMLInputElement).value);
    this.getCategories(this.idComercio);
    this.cargaProductos(this.cateSelected);
  }






}
